/**
 * Design constants for MetricTile component
 */

export const METRIC_TILE_DESIGN = {
    /** Base scale factor for all tile dimensions */
    SCALE: 0.7,

    /** Threshold for value length before scaling down font size */
    VALUE_LENGTH_THRESHOLD: 10,

    /** Minimum scale factor for value font size */
    VALUE_SCALE_MIN: 0.6,

    /** Factor by which to reduce font size per character over threshold */
    VALUE_SCALE_FACTOR: 0.035,

    /** Font sizes in pixels (before scaling) */
    FONT_SIZES: {
        LABEL_LG: 11,
        LABEL_MD: 10,
        VALUE_LG: 28,
        VALUE_MD: 22,
        UNIT: 12,
        HELPER: 11
    },

    /** Icon sizes in pixels (before scaling) */
    ICON_SIZES: {
        LG: 18,
        MD: 16
    },

    /** Padding values (before scaling) */
    PADDING: {
        LG: 2.5,
        MD: 2
    },

    /** Spacing values (before scaling) */
    SPACING: {
        VALUE_LG: 1.5,
        VALUE_MD: 1
    },

    /** Letter spacing for labels */
    LETTER_SPACING: 0.3,

    /** Helper text minimum height in pixels (after scaling) */
    HELPER_MIN_HEIGHT: 16
} as const;
